import KunLoading9 from './src/index'

KunLoading9.install = function (Vue) {
	Vue.component(KunLoading9.name, KunLoading9);
}

export default KunLoading9;
